import React from "react";
import { ShieldCheck } from "lucide-react";

export const VerifiedBadge = ({ size = "md", testId = "verified-badge" }) => {
  const sm = size === "sm";
  return (
    <span
      className={`inline-flex items-center gap-1 font-semibold uppercase tracking-[0.14em] text-emerald-800 bg-emerald-50 border border-emerald-300 rounded-full ${sm ? "text-[9px] px-1.5 py-0.5" : "text-[10px] px-2.5 py-1"}`}
      title="Verified Supplier — business registration confirmed by Accommodation Suppliers"
      data-testid={testId}
    >
      <ShieldCheck className={sm ? "w-3 h-3" : "w-3.5 h-3.5"} /> Verified Supplier
    </span>
  );
};

export default VerifiedBadge;
